import { render, staticRenderFns } from "./AuditActivityStream.vue?vue&type=template&id=567bcd42&"
import script from "./AuditActivityStream.vue?vue&type=script&lang=js&"
export * from "./AuditActivityStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports